import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnChanges } from '@angular/core';
import { texts } from './candidate-analysis.texts';

@Component({
  standalone: false,
  selector: 'app-candidate-analysis',
  templateUrl: './candidate-analysis.component.html',
  styleUrls: ['./candidate-analysis.component.scss'],
  animations: [
    trigger('expand', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('200ms ease-in-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in-out', style({ height: 0, opacity: 0 }))
      ])
    ])
  ]
})
export class CandidateAnalysisComponent implements OnChanges {

  texts = texts;

  @Input()
  candidate: any;

  requirements: any = [];

  expanded: any = {};

  ngOnChanges() {
    this.expanded = {};
    this.requirements = (this.candidate?.Screening?.RequirementResults ?? [])
      .filter(r => this.isVisibleRequirement(r));
  }

  // only the requirements that read well to a customer, the rest are internal filters
  isVisibleRequirement(r) {
    var type = r.Requirement?.Type;
    return type === 'Skill' || type === 'Custom' || type === 'Industry';
  }

  // requirements carry their wording in the accepted alternatives, not in a title
  title(r) {
    var alternatives = r.Requirement?.Alternatives ?? [];
    if (alternatives.length) return alternatives.join(', ');
    return r.Requirement?.Type;
  }

  toggle(index) {
    this.expanded[index] = !this.expanded[index];
  }

}
